module.exports = __webpack_public_path__ + "static/media/prisutdelning_aggjakten_small.617c224a.jpg";